angular.module("ainapp")
    .controller("vehicleAllocationController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Vehicle Allocation";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })


            $scope.Vehicles = [];
            MainService.GetVehicleCostCenters().then(function (response) {
                $scope.Vehicles = response.data;
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })


            $scope.Init = function () {

                $scope.addData = {
                    Name: "",

                    Remarks: "",
                    Purpose: "",
                    FromDate: null,
                    ToDate: null,

                    FuelLevel: "",
                    Kms: "",
                    Complaints: "",
                    TyreCondition: "",

                    IsHeadlights: false,
                    IsIndicators: false,
                    IsRearFog: false,
                    IsReflectors: false,
                    IsRearLights: false,
                    IsMirrors: false,
                    IsSpareWheel: false,
                    IsTyres: false,
                    IsFuelCap: false,
                    IsAerial: false,
                    IsSideLights: false,
                    IsBumpers: false,
                    IsRadio: false,
                    IsSpeakers: false,
                    IsHeater: false,
                    IsHorn: false,
                    IsWiper: false,
                    IsSeatBelts: false,
                    IsTools: false,
                    IsLocks: false,

                    Photo1: "",
                    Photo2: "",
                    Photo3: "",
                    Photo4: "",
                    Photo5: "",
                    Photo6: "",

                    CostCenterId: "",
                    EmployeeId: "",

                }

                $scope.load = 0;

            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.VehicleAllocationInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            FromDate: {
                                type: "date",
                                editable: false,
                            },
                            ToDate: {
                                type: "date",
                                editable: false,
                            },
                            Remarks: {
                                type: "string",
                                editable: false,
                            },
                            Purpose: {
                                type: "string",
                                editable: false,
                            },
                            FuelLevel: {
                                type: "string",
                                editable: false,
                            },
                            Kms: {
                                type: "string",
                                editable: false,
                            },
                            Complaints: {
                                type: "string",
                                editable: false,
                            },
                            TyreCondition: {
                                type: "string",
                                editable: false,
                            },
                            "CostCenter.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        },
                    {
                        field: "CostCenter.Name",
                        title: "Vehicle",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "<p>{{dataItem.Date | date : 'dd/MM/yyyy'}}</p>"
                        },
                    {
                        field: "FromDate",
                        title: "From Date",
                        template: "<p>{{dataItem.FromDate | date : 'dd/MM/yyyy'}}</p>"
                        },
                    {
                        field: "ToDate",
                        title: "To Date",
                        template: "<p>{{dataItem.ToDate | date : 'dd/MM/yyyy'}}</p>"
                        },
                    {
                        field: "Purpose",
                        title: "Purpose",
                        },
                    {
                        field: "FuelLevel",
                        title: "Fuel Level",
                        },
                    {
                        field: "Kms",
                        title: "Kms",
                        },
                    {
                        field: "Complaints",
                        title: "Complaints",
                        },
                    {
                        field: "TyreCondition",
                        title: "Tyre Condition",
                        },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeletVehicleAllocation($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == "Success") {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    } else {
                        toastr.error(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Edit = function (data) {
                $scope.addData = data;
                //$scope.$apply();
            }


            $scope.SaveData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.addData.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.addData.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
                } else if ($scope.addData.EmployeeId == "") {
                    toastr.warning("Select Employee");
                } else if ($scope.addData.CostCenterId == "") {
                    toastr.warning("Select Vehicle");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    if ($scope.addData.FromDate != null) {
                        $scope.addData.FromDateString = $scope.extractDate($scope.addData.FromDate);
                    }
                    if ($scope.addData.ToDate != null) {
                        $scope.addData.ToDateString = $scope.extractDate($scope.addData.ToDate);
                    }

                    MainService.AddVehicleAllocation($scope.addData).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.error(Failed);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }

                }])
